module.exports = __webpack_public_path__ + "img/icon_map_1.21744f7d.png";